import { createTheme } from '@mui/material/styles';

// Family-friendly color palette
const theme = createTheme({
  palette: {
    primary: {
      main: '#2E7D32', // Forest green - represents growth and family
      light: '#4CAF50',
      dark: '#1B5E20',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FF8A65', // Warm coral - friendly and inviting
      light: '#FFAB91',
      dark: '#FF5722',
      contrastText: '#ffffff',
    },
    background: {
      default: '#FAFAFA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2C2C2C',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      color: '#2C2C2C',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      color: '#2C2C2C',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 500,
      color: '#2C2C2C',
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 500,
      color: '#2C2C2C',
    },
    h5: {
      fontSize: '1.1rem',
      fontWeight: 500,
      color: '#2C2C2C',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      color: '#2C2C2C',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          padding: '8px 16px',
          fontWeight: 500,
        },
        contained: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: 12,
          '&:hover': {
            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
            transform: 'translateY(-2px)',
            transition: 'all 0.3s ease-in-out',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

export default theme;
